import React from 'react';
import { useNavigate } from 'react-router-dom';
import FeaturedSolutions, { AgilysysLogo } from '../components/FeaturedSolutions';

const A = '/assets/casino/solutions/';

const solutions = [
  { name: 'Sales & Catering', path: 'sales', screenshot: A + 'laptop-catering.png' },
];

function Conference() {
  const navigate = useNavigate();
  return (
    <div className="page splash conferencePage">
      <div className="background" />
      <div className="page-header">Conference Center / Ballroom</div>
      <div className="text-blocks">
        <div className="std-text">Make every meeting, social event, ceremony or fundraiser unforgettable with Agilysys Sales &amp; Catering. With convenient event booking, menu selection and comprehensive logistics management, attendees will be guaranteed a truly memorable experience.{"\n\n"}</div>
        <div className="std-text">And increase event revenue with yield management insights for group sales, conference and banqueting.</div>
      </div>
      <FeaturedSolutions>
        {solutions.map((sol) => (
          <div key={sol.path} className="featured-item" onClick={() => navigate(`/solutions/${sol.path}`)}>
            <img src={sol.screenshot} alt={sol.name} />
            <div className="item-head"><AgilysysLogo />{sol.name}</div>
          </div>
        ))}
      </FeaturedSolutions>
    </div>
  );
}

export default Conference;
